<template>
    <div class="font-bold text-5xl">
        <span>PT Umas Jaya Agrotama</span>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
